<template>
  <div class="view-box columns bg-white">
    <settings-header
      button-route="new"
      :header-title="contact.name"
      show-back-button
      :back-button-label="$t('CONTACT_PROFILE.BACK_BUTTON')"
      :back-url="backUrl"
      :show-new-button="false"
    >
    </settings-header>

    <div
      v-if="uiFlags.isFetchingItem"
      class="text-center p-normal fs-default h-full"
    >
      <spinner size="" />
      <span>{{ $t('CONTACT_PROFILE.LOADING') }}</span>
    </div>
    <div
      v-else-if="contact.id"
      class="overflow-hidden column contact--dashboard-content"
    >
      <div class="row h-full">
        <contact-info-panel
          :show-close-button="false"
          :show-avatar="true"
          :contact="contact"
        />
        <contact-opportunities
          v-if="showOpportunities"
          class="small-12 h-full contact--opportunities"
          :contact-id="Number(contactId)"
        />
        <div
          class="small-12 h-full"
          :class="showOpportunities ? 'contact--notes' : 'medium-9'"
        >
          <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
            <woot-tabs-item
              v-for="tab in tabs"
              :key="tab.key"
              :name="tab.name"
              :show-badge="false"
            />
          </woot-tabs>
          <div class="tab-content overflow-auto">
            <contact-notes
              v-if="selectedTabIndex === 0"
              :contact-id="Number(contactId)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ContactInfoPanel from '../components/ContactInfoPanel.vue';
import ContactOpportunities from '../components/ContactOpportunities.vue';
import ContactNotes from 'dashboard/modules/notes/NotesOnContactPage';
import SettingsHeader from '../../settings/SettingsHeader.vue';
import Spinner from 'shared/components/Spinner';
import Thumbnail from 'dashboard/components/widgets/Thumbnail';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export default {
  components: {
    ContactInfoPanel,
    ContactOpportunities,
    ContactNotes,
    SettingsHeader,
    Spinner,
    Thumbnail,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      selectedTabIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
    }),
    showOpportunities() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.OPPORTUNITY_PIPELINES
      );
    },
    tabs() {
      return [
        {
          key: 0,
          name: this.$t('NOTES.HEADER.TITLE'),
        },
      ];
    },
    showEmptySearchResult() {
      const hasEmptyResults = !!this.searchQuery && this.records.length === 0;
      return hasEmptyResults;
    },
    contact() {
      return this.$store.getters['contacts/getContact'](this.contactId);
    },
    backUrl() {
      return `/app/accounts/${this.$route.params.accountId}/contacts`;
    },
  },
  mounted() {
    this.fetchContactDetails();
  },
  methods: {
    onClickTabChange(index) {
      this.selectedTabIndex = index;
    },
    fetchContactDetails() {
      const { contactId: id } = this;
      this.$store.dispatch('contacts/show', { id });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/mixins';

.left {
  border-right: 1px solid var(--color-border);
  overflow: auto;
}

.right {
  padding: var(--space-normal);
}

.tab-content {
  background: var(--color-background-light);
  height: calc(100% - 40px);
  padding: var(--space-normal);
}

@media (min-width: 640px) {
  .contact--opportunities {
    border-right: 1px solid var(--color-border);
    flex: 0 0 35%;
    max-width: 56rem;
    min-width: 32rem;
  }

  .contact--notes {
    flex: 1 1 0;
    max-width: none;
    min-width: 0;
  }
}
</style>
